import React, { lazy, Suspense, useMemo } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useAuth } from "../store/AuthContext.js";
import ProtectedRoute from "./ProtectedRoute";


const Login = lazy(() => import("../pages/Login.jsx"));
const Clubs = lazy(() => import("../pages/Clubs.jsx"));
const ClubDetails = lazy(() => import("../pages/ClubDetails.jsx"));
const AddClub = lazy(() => import("../pages/AddClub.jsx"));
const EditClub = lazy(() => import("../pages/EditClub.jsx"));
const Subscriptions = lazy(() => import("../pages/Subscriptions.jsx"));
const AddSubscription = lazy(() => import("../pages/AddSubscription.jsx"));
const EditSubscription = lazy(() => import("../pages/EditSubscription.jsx"));
const Competitions = lazy(() => import("../pages/Competitions.jsx"));
const Players = lazy(() => import("../pages/Players.jsx"));
const Financial = lazy(() => import("../pages/Financial.jsx"));
const Events = lazy(() => import("../pages/Events.jsx"));
const Settings = lazy(() => import("../pages/Settings.jsx"));


export const ROUTES = {
  LOGIN: "/",
  CLUBS: "/clubs",
  CLUBS_DETAILS: "/club/:id",
  CLUBS_EDIT: "/club/edit/:id",
  CLUBS_ADD: "/clubs/add",
  SUBSCRIPTIONS: "/subscriptions",
  SUBSCRIPTIONS_ADD: "/subscriptions/add",
  SUBSCRIPTIONS_EDIT: "/subscriptions/edit/:id",
  COMPETITIONS: "/competitions",
  PLAYERS: "/players",
  FINANCIAL: "/finacial",
  EVENTS: "/events",
  SETTINGS: "/settings",
};

export default function AppRoutes() {
  const { isAuthenticated } = useAuth();

  const protectedRoutes = useMemo(() => (
    <Routes>
        <Route path={ROUTES.CLUBS} element={<Clubs />} />
        <Route path={ROUTES.CLUBS_DETAILS} element={<ClubDetails />} />
        <Route path={ROUTES.CLUBS_ADD} element={<AddClub />} />
        <Route path={ROUTES.CLUBS_EDIT} element={<EditClub />} />
        <Route path={ROUTES.SUBSCRIPTIONS} element={<Subscriptions />} />
        <Route path={ROUTES.SUBSCRIPTIONS_ADD} element={<AddSubscription />} />
        <Route path={ROUTES.SUBSCRIPTIONS_EDIT} element={<EditSubscription />} />
        <Route path={ROUTES.COMPETITIONS} element={<Competitions />} />
        <Route path={ROUTES.PLAYERS} element={<Players />} />
        <Route path={ROUTES.FINANCIAL} element={<Financial />} />
        <Route path={ROUTES.EVENTS} element={<Events />} />
        <Route path={ROUTES.SETTINGS} element={<Settings />} />
    </Routes>
  ), []);

  return (
    <BrowserRouter>
      <Suspense>
        <Routes>
          <Route path={ROUTES.LOGIN} element={<Login />} />          
          <Route
            path="*"
            element={
              <ProtectedRoute isAuthenticated={isAuthenticated}>
                {protectedRoutes}
              </ProtectedRoute>
            }
          />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
